export const PORTFOLIO_CONFIGURATION_GROUP_MACRO = {
  immobilier: 'immobilier',
  biensMobiliers: 'biens_mobiliers',
  financier: 'financier',
  actifsPro: 'actifs_pro',
  capitauxPrevoyance: 'capitaux_prevoyance',
  emprunt: 'emprunt',
}

export const GROUP_MACRO_ORDER = {
  [PORTFOLIO_CONFIGURATION_GROUP_MACRO.immobilier]: 0,
  [PORTFOLIO_CONFIGURATION_GROUP_MACRO.biensMobiliers]: 1,
  [PORTFOLIO_CONFIGURATION_GROUP_MACRO.financier]: 2,
  [PORTFOLIO_CONFIGURATION_GROUP_MACRO.actifsPro]: 3,
  [PORTFOLIO_CONFIGURATION_GROUP_MACRO.capitauxPrevoyance]: 4,
  [PORTFOLIO_CONFIGURATION_GROUP_MACRO.emprunt]: 5,
}

export const PORTFOLIO_CONFIGURATION_PRODUCT_GROUP = {
  av: 'PRODUCT_GROUP.av',
  cpteDepot: 'PRODUCT_GROUP.cpte_depot',
  emprunt: 'PRODUCT_GROUP.emprunt',
  epargne: 'PRODUCT_GROUP.epargne',
  furniture: 'PRODUCT_GROUP.furniture',
  immob: 'PRODUCT_GROUP.immob',
  mobiliere: 'PRODUCT_GROUP.mobiliere',
  nonDefini: 'PRODUCT_GROUP.non_defini',
  pea: 'PRODUCT_GROUP.pea',
  prevoyance: 'PRODUCT_GROUP.prevoyance',
  pro: 'PRODUCT_GROUP.pro',
  retraite: 'PRODUCT_GROUP.retraite',
}

export type PortfolioConfigurationProductGroupKey =
  keyof typeof PORTFOLIO_CONFIGURATION_PRODUCT_GROUP

export const ORDERED_PRODUCT_CATEGORIES = [
  'biens_d_usage',
  'immobilier_de_rapport',
  'autre_immobilier',
  'assurance_vie',
  'disponibilites',
  'biens_professionnels',
  'valeurs_mobilieres',
  'epargne_retraite_et_salariale',
  'epargne_moyen_et_long_terme',
  'prevoyance',
  'emprunt_sur_residence_principale',
  'emprunt_immobilier',
  'emprunt_professionnel',
  'dettes_diverses',
  'financial_assets',
  'real_estate_assets',
  'compte_courant',
  'livret_de_developpement_durable_et_solidaire_ldds',
  'compte_epargne_logement_cel',
  'peepei',
  'plan_depargne_logement_pel',
  'livret_a',
]

export enum PRODUCT_CATEGORY {
  assuranceVie = 'assurance_vie',
  biensUsage = 'biens_d_usage',
  biensProfessionnels = 'biens_professionnels',
  dettesDiverses = 'dettes_diverses',
  disponibilites = 'disponibilites',
  empruntImmobilier = 'emprunt_immobilier',
  empruntProfessionnel = 'emprunt_professionnel',
  epargneMoyenEtLongTerme = 'epargne_moyen_et_long_terme',
  epargneRetraiteEtSalariale = 'epargne_retraite_et_salariale',
  immobilierDeRapport = 'immobilier_de_rapport',
  prevoyance = 'prevoyance',
  valeursMobilieres = 'valeurs_mobilieres',
  gff = 'parts_de_groupements_forestiers',
  undefined = 'non_defini',
  autreImmobilier = 'autre_immobilier',
}

export const PRODUCT_CATEGORY_PARENTS = {
  investment: 'investment',
  loan: 'loan',
  insurance: 'insurance',
  realEstate: 'realEstate',
}

export const PRODUCT_CATEGORIES_INVESTMENT: PRODUCT_CATEGORY[] = [
  PRODUCT_CATEGORY.assuranceVie,
  PRODUCT_CATEGORY.disponibilites,
  PRODUCT_CATEGORY.valeursMobilieres,
  PRODUCT_CATEGORY.epargneRetraiteEtSalariale,
  PRODUCT_CATEGORY.epargneMoyenEtLongTerme,
]

export const PRODUCT_CATEGORIES_LOAN: PRODUCT_CATEGORY[] = [
  PRODUCT_CATEGORY.empruntImmobilier,
  PRODUCT_CATEGORY.empruntProfessionnel,
  PRODUCT_CATEGORY.dettesDiverses,
]

export const PRODUCT_CATEGORIES_INSURANCE: PRODUCT_CATEGORY[] = [
  PRODUCT_CATEGORY.prevoyance,
]

export const PRODUCT_CATEGORIES_REAL_ESTATE: PRODUCT_CATEGORY[] = [
  PRODUCT_CATEGORY.immobilierDeRapport,
  PRODUCT_CATEGORY.biensUsage,
  PRODUCT_CATEGORY.biensProfessionnels,
  PRODUCT_CATEGORY.autreImmobilier,
]

export const PRODUCT_CATEGORIES_BY_PARENT = {
  [PRODUCT_CATEGORY_PARENTS.investment]: PRODUCT_CATEGORIES_INVESTMENT,
  [PRODUCT_CATEGORY_PARENTS.loan]: PRODUCT_CATEGORIES_LOAN,
  [PRODUCT_CATEGORY_PARENTS.insurance]: PRODUCT_CATEGORIES_INSURANCE,
  [PRODUCT_CATEGORY_PARENTS.realEstate]: PRODUCT_CATEGORIES_REAL_ESTATE,
}

export const PRODUCT_KIND = {
  actifInconnu: 'actif_inconnu',
  actionsEtrangeres: 'actions_etrangeres',
  actionsFrancaisesEtEuropeennes: 'actions_francaises_et_europeennes',
  article82: 'article_82',
  article83: 'article_83',
  articleThirtyNine: 'article_39',
  autresBiensDUsage: 'autres_biens_dusage',
  autresBiensProfessionnels: 'autres_biens_professionnels',
  autresDepots: 'autres_depots',
  autresDisponibilites: 'autres_disponibilites',
  autresDroitsSociaux: 'autres_droits_sociaux',
  autresImmeublesDeRapport: 'autres_immeubles_de_rapport',
  autresPlacementsDivers: 'autres_placements_divers',
  autresValeursMobilieres: 'autres_valeurs_mobilieres',
  biensRurauxLouesALongTerme: 'biens_ruraux_loues_a_long_terme',
  boisEtForets: 'bois_et_forets',
  bonsDeCaisse: 'bons_de_caisse',
  bonsEtContratsDeCapitalisation: 'bons_et_contrats_de_capitalisation',
  capitalDePmeTpe: 'capital_de_pmetpe',
  capitalDiffere: 'capital_differe',
  compteATerme: 'compte_a_terme',
  compteCourant: 'compte_courant',
  compteCourantDAssocies: 'compte_courant_dassocies',
  compteEpargneLogementCel: 'compte_epargne_logement_cel',
  compteSurLivretCsl: 'compte_sur_livret_csl',
  compteTitres: 'compte_titres',
  contratPrevoyanceIndividuelle: 'contrat_prevoyance_individuelle',
  contratVieGeneration: 'contrat_vie_generation',
  conventionObseques: 'convention_obseques',
  creditALaConsommation: 'credit_a_la_consommation',
  creditAutresBiensImmobiliers: 'credit_autres_biens_immobiliers',
  creditAutresBiensProfessionnels: 'credit_autres_biens_professionnels',
  creditAutresDettesDiverses: 'credit_autres_dettes_diverses',
  creditBiensDeRapport: 'credit_biens_de_rapport',
  creditBiensDUsage: 'credit_biens_dusage',
  creditDettesFamiliales: 'credit_dettes_familiales',
  creditDettesFiscales: 'credit_dettes_fiscales',
  creditDImpotAcquisitionRpDansLeNeuf:
    'credit_dimpot_acquisition_rp_dans_le_neuf',
  creditDImpotAcquisitionRpDansLeVieux:
    'credit_dimpot_acquisition_rp_dans_le_vieux',
  creditDImpotBatimentBasseConsommation:
    'credit_dimpot_batiment_basse_consommation',
  creditDroitsSociaux: 'credit_droits_sociaux',
  creditFacilitesDeTresorerie: 'credit_facilites_de_tresorerie',
  creditFondsDeCommerce: 'credit_fonds_de_commerce',
  creditImmobilierProfessionnel: 'credit_immobilier_professionnel',
  creditScpiEtSci: 'credit_scpi_et_sci',
  droitsSociaux: 'droits_sociaux',
  droitsSociauxDeSalariesMandataires: 'droits_sociaux_de_salaries_mandataires',
  droitsSociauxPacteDutreil: 'droits_sociaux_pacte_dutreil',
  entrepriseIndividuelle: 'entreprise_individuelle',
  fcpi: 'fcpi',
  fcpr: 'fcpr',
  fip: 'fip',
  fipCorse: 'fip_corse',
  fondsDeCommerceClienteles: 'fonds_de_commerce_clienteles',
  hommeCle: 'homme_cle',
  immeubleLocatifLoueNu: 'immeuble_locatif_loue_nu',
  immeubleLoueMeubleLmnp: 'immeuble_loue_meuble_lmnp',
  immeubleLoueMeubleLmp: 'immeuble_loue_meuble_lmp',
  immeublesProfessionnelsHorsLmp: 'immeubles_professionnels_hors_lmp',
  lifeInsurance: 'assurance_vie',
  livretA: 'livret_a',
  livretBleus: 'livret_bleus',
  livretDeDeveloppementDurableEtSolidaireLdds:
    'livret_de_developpement_durable_et_solidaire_ldds',
  livretDEpargnePopulaireLep: 'livret_depargne_populaire_lep',
  livretJeune: 'livret_jeune',
  lmnpBouvard: 'lmnp_bouvard',
  madelin: 'madelin',
  madelinAgricole: 'madelin_agricole',
  meubleMeublant: 'meuble_meublant',
  objetsDartEtAntiquites: 'objets_dart_et_antiquites',
  obligations: 'obligations',
  partsDeGfaGafGfvEtGfrGroupementsFonciers:
    'parts_de_gfa_gaf_gfv_et_gfr_groupements_fonciers',
  partsDeGroupementsForestiers: 'parts_de_groupements_forestiers',
  partsDeHolding: 'parts_de_holding',
  partsDeSci: 'parts_de_sci',
  partsDeScpi: 'parts_de_scpi',
  partsDeSocietesDEpargneForestiere: 'parts_de_societes_depargne_forestiere',
  passifInconnu: 'passif_inconnu',
  pea: 'pea',
  peaPme: 'pea_pme',
  peepei: 'peepei',
  pepAssuranceVie: 'pep_assurance_vie',
  pepBancaire: 'pep_bancaire',
  percopercoi: 'percopercoi',
  perEntrepriseObligatoire: 'per_entreprise_obligatoire',
  perIndividuel: 'per_individuel',
  perp: 'perp',
  planDEpargneLogementPel: 'plan_depargne_logement_pel',
  prefonRetraite: 'prefon_retraite',
  residencePrincipale: 'residence_principale',
  residenceSecondaire: 'residence_secondaire',
  retraiteMutualisteDuCombattant: 'retraite_mutualiste_du_combattant',
  sansCreditDImpot: 'sans_credit_dimpot',
  sicavFcpActions: 'sicav_fcp_actions',
  sicavFcpMonetaire: 'sicav_fcp_monetaire',
  sicavFcpObligations: 'sicav_fcp_obligations',
  sofica: 'sofica',
  stockOptions: 'stock_options',
  temporaireDeces: 'temporaire_deces',
  terrain: 'terrain',
  terrainsAgricoles: 'terrains_agricoles',
  vieEntiere: 'vie_entiere',
} as const

export type ProductKind = ValueOf<typeof PRODUCT_KIND>

export const PORTFOLIO_ESTABLISHMENT_TYPES = {
  nonSignificative: 'non_significative',
  internal: 'internal',
  external: 'external',
} as const

export type PortfolioEstablishmentType = ValueOf<
  typeof PORTFOLIO_ESTABLISHMENT_TYPES
>

export const PORTFOLIO_UX_CONTEXTS = {
  inTable: 'inTable',
  linkedPortfolio: 'linkedPortfolio',
}

export const PORTFOLIO_COUNTRY_CODES = {
  fr: 'FR',
} as const

export const GRAPH_GROUP_MACROS = [
  PORTFOLIO_CONFIGURATION_GROUP_MACRO.financier,
  PORTFOLIO_CONFIGURATION_GROUP_MACRO.immobilier,
  PORTFOLIO_CONFIGURATION_GROUP_MACRO.biensMobiliers,
  PORTFOLIO_CONFIGURATION_GROUP_MACRO.actifsPro,
  PORTFOLIO_CONFIGURATION_GROUP_MACRO.emprunt,
]

export const INSURED_TYPE = {
  jointFirstToDie: 'joint_first_to_die',
  jointSecondToDie: 'joint_second_to_die',
}
